import Inferno from 'inferno';
import App from './App/app';
import './index.css';

Inferno.render(
  <App />,
  document.getElementById('app')
);


// WEBPACK FOOTER //
// ./index.js